// extracted by mini-css-extract-plugin
export default {"root":"XgzWf","item":"u5jlK","itemTitle":"G62De","itemInner":"FdCPo","propertiesRow":"XiK3U"};